import type { PrescriptionAssistantSliceType } from '../types';

// check if prescription pad is in sync with prescription history
export const isPrescriptionPadInSync = (get: () => PrescriptionAssistantSliceType) => {
  const state = get();
  const previousPrescribedItems = new Map(
    state.prescriptionAssistant.prescriptionHistory.previousItems.map((item) => [item.id, item])
  );
  const prescriptionPadItems = state.prescriptionAssistant.prescriptionPad.medicationPadItems;

  // skip sync check for empty prescription pad
  if (!prescriptionPadItems.length) {
    return true;
  }

  return prescriptionPadItems.every((item) => {
    const previousItem = previousPrescribedItems.get(item.medicationPadItem?.productId ?? -1);
    // if previous item is not found in the current prescription pad, skip the sync check
    if (!previousItem) {
      return true;
    }

    // check if status matches previous medication
    if (item?.prescriptionStatus !== previousItem?.prescriptionStatus) {
      return false;
    }

    // if item is being reissued then check if the created date is the same
    return item?.reissueStatus?.createdDate === previousItem?.reissueStatus?.createdDate;
  });
};
